const procurementCapabilities = [
    {
      id: 1,
      title: "Sourcing & Supply Chain Management",
      description:
        "We specialize in end-to-end procurement solutions, ensuring that oilfield companies receive genuine, industry-standard materials and equipment.",
      services: [
        "Vendor evaluation and selection",
        "Competitive sourcing strategies",
        "Logistics and transportation management",
        "Inventory control and supply chain optimization",
      ],
    },
    {
      id: 2,
      title: "Oilfield Equipment & Machinery Supply",
      description:
        "We provide a comprehensive range of oil and gas equipment and machinery, ensuring that our clients have the right tools and technology to enhance their operations.",
      services: [
        "Drilling Equipment: Rigs, drill pipes, casings, blowout preventers",
        "Production Equipment: Wellheads, separators, pumps, compressors",
        "Pipeline Equipment: Pipes, valves, fittings, gaskets, flanges",
        "Instrumentation & Control Systems: Flow meters, pressure gauges, SCADA systems",
        "Safety & Protection Gear: Fire-resistant clothing, helmets, gloves, boots",
      ],
    },
    {
      id: 3,
      title: "Structural & Mechanical Components",
      description:
        "Our procurement services cover a vast range of structural and mechanical components, essential for oilfield operations, facility construction, and maintenance.",
      services: [
        "Structural steel (plates, beams, bars)",
        "Pressure vessels and storage tanks",
        "Bolts, nuts, fasteners, and connectors",
        "Welding consumables and accessories",
      ],
    },
    {
      id: 4,
      title: "Electrical & Instrumentation Supplies",
      description:
        "Our extensive range of electrical and instrumentation materials ensures that oil and gas facilities operate with maximum efficiency and safety.",
      services: [
        "Power distribution systems (cables, switchgear, transformers)",
        "Lighting systems (industrial LED, explosion-proof lighting)",
        "Control systems (PLC, SCADA, automation panels)",
        "Electrical fittings and enclosures",
      ],
    },
    {
      id: 5,
      title: "Corrosion Protection & Coating Solutions",
      description:
        "Corrosion poses a significant challenge in the oil and gas industry, leading to potential failures and costly downtimes. We provide advanced corrosion prevention solutions to protect critical infrastructure.",
      services: [
        "Protective coatings (epoxy, polyurethane, zinc coatings)",
        "Cathodic protection systems (anodes, rectifiers, test stations)",
        "Anti-corrosion tapes and wraps",
        "Rust inhibitors and chemical treatments",
      ],
    },
    {
      id: 6,
      title: "Pipeline & Flowline Materials",
      description:
        "We supply a wide range of pipeline materials for offshore and onshore applications, ensuring that oil and gas companies maintain safe and efficient transportation of hydrocarbons.",
      services: [
        "Seamless and welded steel pipes",
        "Pipe fittings (elbows, tees, reducers)",
        "Flanges, gaskets, and seals",
        "Heat exchangers and pressure regulators",
      ],
    },
  ];
  
  export default procurementCapabilities;
  